import { useState } from 'react';
import { useRouter } from 'next/router';
import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls';
// Panels that have a URL of their own. Switching to one of these from a page that does not own it is
// a navigation, so the address bar keeps matching what is on screen. Panels absent from this map
// (`reset`, `transfer`) are only ever reached through their own emailed link, never by switching.
const MODE_URLS = {
    signin: routeUrls.signIn,
    signup: routeUrls.signUp,
    forgot: routeUrls.forgotPassword,
};
// Mode state for a standalone auth page: swap in place for the panels the page owns, navigate for the
// ones that belong to another page.
export const useAuthPageMode = ({ initialMode, ownedModes = [initialMode] }) => {
    const router = useRouter();
    const [mode, setMode] = useState(initialMode);
    const onModeChange = (nextMode) => {
        const url = ownedModes.includes(nextMode) ? undefined : MODE_URLS[nextMode];
        if (url) {
            void router.push(url());
            return;
        }
        setMode(nextMode);
    };
    return { mode, onModeChange };
};
